// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"14aecffa","332":"45ef1bdd","538":"6b01a7a8","562":"a8d5c35a","635":"88b950d7"}[chunkId] + ".chunk.css";
};